<script setup lang="ts">
import type { IDashboardWidgetProps, TWidgetEmits } from '@tenorlab/vue-dashboard'
import { DashboardWidgetBase, WrapperColumnContent, useWidgetEmits } from '@tenorlab/vue-dashboard'

const props = defineProps<IDashboardWidgetProps>()
const emits = defineEmits<TWidgetEmits>()
const emitHandlers = useWidgetEmits(emits)
</script>

<template>
  <DashboardWidgetBase v-bind="props" v-on="emitHandlers">
    <WrapperColumnContent>
      <div class="dashboard-number number-xl text-primary">1,250</div>
      <div class="text-sm">Orders this month</div>
    </WrapperColumnContent>
  </DashboardWidgetBase>
</template>
